<!-- eslint-disable @typescript-eslint/no-explicit-any -->
<script setup lang="ts">
  import type { FieldConfig, FormData } from '@/types'

  const props = defineProps<{
    field: FieldConfig,
    formData: FormData,
  }>()

  const emit = defineEmits<{
    (e: 'update-field', key: string, value: any): void,
  }>()

  const getValue = (optionKey: string): boolean => {
    const fieldData = props.formData[props.field.key as keyof FormData] as Record<string, boolean> | undefined
    return fieldData?.[optionKey] ?? false
  }
</script>

<template>
  <div>
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 sm:gap-4 mt-2">
      <label
        v-for="option in field.options || []"
        :key="option.key"
        class="flex items-center gap-2 cursor-pointer group">
        <div class="relative">
          <input
            type="checkbox"
            class="absolute opacity-0 size-0 peer"
            :checked="getValue(option.key ?? '')"
            @input="emit(
              'update-field',
              `${field.key}.${option.key}`,
              !getValue(option.key ?? '')
            )">
          <span class="pointer-events-none size-5 flex items-center justify-center border-[1.5px] border-gray-300 rounded-[5.5px] transition-all duration-200 ease-in-out peer-checked:bg-primary-50 peer-focus-visible:ring-2 peer-focus-visible:ring-offset-1 peer-focus-visible:outline-none peer-checked:border-primary-700 peer-focus-visible:ring-primary-700/50">
            <svg
              v-if="getValue(option.key ?? '')"
              class="text-primary-700 size-3"
              viewBox="0 0 20 20"
              fill="currentColor">
              <path
                fill-rule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clip-rule="evenodd" />
            </svg>
          </span>
        </div>
        <span class="text-gray-700 text-xs xl:text-sm">{{ option.label }}</span>
      </label>
    </div>
  </div>
</template>

